import { useLocation } from "react-router";
import { useEffect, useState } from "react";

const ScrollTop = ({ children }: any) => {
  const location = useLocation();

  const [current, setLocation] = useState(location.pathname);

  useEffect(() => {
    const next = location.pathname;
    const hash = location.hash;
    if (next !== current && !hash) {
      setTimeout(() => {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
      }, 10);
      setLocation(next);
    }
  }, [current, location.pathname, location.hash]);


  return children;
};

export default ScrollTop;
